import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

const GlobalContext = createContext();

// const API_BASE_URL = process?.env?.REACT_APP_API_BASE_URL;

export const GlobalProvider = ({ children }) => {
  /**
   * @type {string}
   * The base URL for the API. Defaults to 'https://localhost:5001' if API_BASE_URL is not defined.
   */
  const [apiBaseUrl] = useState(
    process.env.REACT_APP_API_BASE_URL || "https://localhost:5001"
  );
  const [loading, setLoading] = useState(true);
  const [mappers, setMappers] = useState([]);

  const [defaultMapper, setDefaultMapper] = useState(undefined);
  // const DBStorageKey = "DBStorage";

  useEffect(() => {
    const fetchDbData = async () => {
      try {
        const response = await axios.get(`/api/mappers`);
        setMappers(response.data);
        if (response.data.length > 0) {
          axios.defaults.headers.common["Mapper"] = response.data[0];

          let activeMapper =
            JSON.parse(localStorage.getItem("LastSelectedMapper")) ||
            response.data[0];
          // _setDefaultMapper(response.data[0]);
          _setDefaultMapper(activeMapper);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }

      setLoading(false);
    };

    // setting default base url
    axios.defaults.baseURL = apiBaseUrl;
    console.log("Default base url set to " + apiBaseUrl);
    fetchDbData();
  }, []);

  function _setDefaultMapper(newDefaultMapper) {
    console.log("Default mapper set to " + newDefaultMapper);
    axios.defaults.headers.common["Mapper"] = newDefaultMapper;
    setDefaultMapper(newDefaultMapper);
  }

  const contextValue = {
    dbData: mappers,
    globalDb: defaultMapper,
    mappers,
    defaultMapper,
    apiBaseUrl,
    loading,
    setDefaultMapper: _setDefaultMapper,
  };

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  );
};

/**
 * @typedef {Object} GlobalContextValue
 * @property {Array} dbData - The array of mappers fetched from the API.
 * @property {Object} globalDb - The default mapper object.
 * @property {Array{string}} mappers - The array of mappers fetched from the API.
 * @property {string} defaultMapper - The default mapper object.
 * @property {string} apiBaseUrl - The base URL for the API.
 * @property {boolean} loading - The loading state indicating if data is being fetched.
 * @property {Function} setDefaultMapper - Function to set the default mapper.
 */
export default GlobalContext;
